import { render, staticRenderFns } from "./MessagesListItem.vue?vue&type=template&id=66893565&scoped=true&"
import script from "./MessagesListItem.vue?vue&type=script&lang=js&"
export * from "./MessagesListItem.vue?vue&type=script&lang=js&"
import style0 from "./MessagesListItem.vue?vue&type=style&index=0&id=66893565&scoped=true&lang=css&"
import style1 from "./MessagesListItem.vue?vue&type=style&index=1&id=66893565&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66893565",
  null
  
)

export default component.exports